import { callReconcentralGraphQL } from "src/utilities/AWSServices";

const S3_KEY = "arqa/results/2026/04/summary.json";

/**
 * Gets a presigned URL for a given S3 key via Reconcentral AppSync.
 */
export const fetchPresignedUrl = async (jwtToken, s3Key) => {
  const mutation = `mutation GetPresignedUrl($s3Key: String!) {
    getPresignedUrl(s3Key: $s3Key)
  }`;
  const response = await callReconcentralGraphQL(mutation, { s3Key });
  const result = JSON.parse(response.data.getPresignedUrl);
  if (result.error) {
    throw new Error(result.error);
  }
  return result.presigned_url;
};

/**
 * Calls Reconcentral AppSync to get a presigned URL for the ARQA summary,
 * then fetches the actual data from that presigned URL.
 */
export const fetchArqaData = async (jwtToken) => {
  const presignedUrl = await fetchPresignedUrl(jwtToken, S3_KEY);
  const dataResponse = await fetch(presignedUrl);

  if (!dataResponse.ok) {
    throw new Error(`S3 data fetch failed: ${dataResponse.status}`);
  }

  const data = await dataResponse.json();
  return { items: data?.items || [], ratings: data?.ratings || null };
};
